import React from 'react';
import { Link } from 'react-router-dom';

const posts = [
  {
    slug: 'sirs-baseline-funding-plan-florida',
    title: 'How to Calculate a Compliant SIRS Baseline Funding Plan in Florida (2026)',
    description: 'Step-by-step guide to turning your engineering report into a 30-year HB 913-compliant reserve projection that keeps balances above $0.',
    date: 'May 2026',
    readTime: '12 min read',
  },
  {
    slug: 'florida-condo-board-personal-liability-sirs',
    title: 'Can Florida Condo Board Members Be Personally Liable for SIRS Non-Compliance?',
    description: 'What your real legal exposure is, how the business judgment rule protects you, and the seven steps that build a defensible record.',
    date: 'May 2026',
    readTime: '11 min read',
  },
  {
    slug: 'avoid-condo-assessment-shock-south-florida',
    title: 'How to Avoid Assessment Shock: A South Florida Condo Board Guide to SIRS Funding',
    description: 'Why Miami-Dade and Broward condos are facing the largest assessments in the country — and how a baseline funding plan changes the math.',
    date: 'May 2026',
    readTime: '13 min read',
  },
  {
    slug: 'dbpr-condo-compliance-fines-florida',
    title: 'DBPR Condo Compliance Fines: What Happens If Your Association Misses SIRS Deadlines',
    description: 'Understanding DBPR enforcement, condo penalties, and how a compliant baseline funding plan protects your board from state intervention.',
    date: 'May 2026',
    readTime: '9 min read',
    category: 'Compliance'
  },
  {
    slug: 'sirs-component-list-hb-913-florida',
    title: 'The HB 913 Structural Integrity Reserve Study Component List: Plain-English Guide for Florida Condo Boards',
    description: 'A plain-English breakdown of the 8 mandatory SIRS components under HB 913, what each one means, and how they connect to your baseline funding calculations.',
    date: 'May 2026',
    readTime: '10 min read',
    category: 'SIRS Basics'
  },
  {
    slug: 'south-florida-sirs-miami-dade-broward',
    title: 'Miami-Dade, Broward, and Palm Beach: South Florida\'s Most Complex SIRS Compliance Environment',
    description: 'South Florida condo boards face a unique convergence of state SIRS requirements, county recertification mandates, coastal structural pressures, and insurance market turbulence.',
    date: 'May 2026',
    readTime: '10 min read',
    category: 'South Florida'
  },
  {
    slug: 'full-funding-vs-baseline-sirs-florida',
    title: 'Full Funding vs. Baseline Funding Under HB 913: Which Schedule Is Right for Your Florida Condo?',
    description: 'Florida\'s HB 913 introduced the baseline funding plan as the minimum standard for SIRS reserves. Here\'s what it means, how it differs from full funding, and how to transition.',
    date: 'May 2026',
    readTime: '11 min read',
    category: 'Funding Plans'
  },
];

export default function Blog() {
  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ background: '#1B3A5C', padding: '60px 24px 48px' }}>
        <div style={{ maxWidth: 780, margin: '0 auto' }}>
          <p style={{ color: '#2A9D8F', fontWeight: 600, fontSize: 14, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
            Resources
          </p>
          <h1 style={{ color: '#fff', fontSize: 36, fontWeight: 700, margin: '0 0 16px', lineHeight: 1.25 }}>
            Florida SIRS Compliance Guides
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 17, margin: 0, maxWidth: 560 }}>
            Plain-English guidance for Florida condo board members, treasurers, and property managers navigating HB 913.
          </p>
        </div>
      </div>

      {/* Posts */}
      <div style={{ maxWidth: 780, margin: '0 auto', padding: '48px 24px' }}>
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            style={{ textDecoration: 'none' }}
          >
            <div style={{
              borderBottom: '1px solid #e8ecf0',
              padding: '32px 0',
              cursor: 'pointer',
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.75')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
            >
              <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 10 }}>
                {post.date} · {post.readTime}
              </p>
              <h2 style={{ color: '#1B3A5C', fontSize: 22, fontWeight: 700, margin: '0 0 10px', lineHeight: 1.35 }}>
                {post.title}
              </h2>
              <p style={{ color: '#4b5563', fontSize: 16, margin: '0 0 14px', lineHeight: 1.6 }}>
                {post.description}
              </p>
              <span style={{ color: '#2A9D8F', fontWeight: 600, fontSize: 14 }}>
                Read article →
              </span>
            </div>
          </Link>
        ))}
      </div>

      {/* CTA */}
      <div style={{ background: '#f0f9f8', borderTop: '1px solid #d1f0ec', padding: '48px 24px', textAlign: 'center' }}>
        <h3 style={{ color: '#1B3A5C', fontSize: 22, fontWeight: 700, marginBottom: 12 }}>
          Ready to build your compliant funding plan?
        </h3>
        <p style={{ color: '#4b5563', fontSize: 16, marginBottom: 24 }}>
          Upload your SIRS engineering report and generate a 30-year baseline projection in under an hour.
        </p>
        <a
          href="/app"
          style={{
            background: '#2A9D8F', color: '#fff', padding: '14px 32px',
            borderRadius: 8, textDecoration: 'none', fontWeight: 700, fontSize: 15,
            display: 'inline-block',
          }}
        >
          Start Free →
        </a>
      </div>

      {/* Footer disclaimer */}
      <div style={{ maxWidth: 780, margin: '0 auto', padding: '32px 24px' }}>
        <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.6 }}>
          FloridaSIRS.org generates financial projections based on data from your Structural Integrity Reserve Study. Content on this site does not constitute legal, engineering, or financial advice. Consult your licensed professionals for compliance determinations. FloridaSIRS.org is not affiliated with the Florida Department of Business and Professional Regulation (DBPR).
        </p>
      </div>
    </div>
  );
}
